import React, { useState, useEffect, useRef } from 'react';
import {
  View,
  Text,
  StyleSheet,
  ScrollView,
  TouchableOpacity,
  Modal,
  ActivityIndicator,
  SafeAreaView,
  Dimensions,
  Platform,
  Image,
  TextInput,
} from 'react-native';
import { useNavigation, useFocusEffect, useRoute } from '@react-navigation/native';
import { getMyCouponById, formatClaimedCouponForDisplay } from '../services/couponsApi';
import { openCouponDetail } from '../navigation/navigateToClaimedCoupon';
import { useCustomAlertModal } from '../components/CustomAlertModal';

export default function ShowCouponScreen() {
  const navigation = useNavigation();
  const route      = useRoute();
  const coupon_id  = route.params?.coupon_id;

  const onHiddenModal = () => {
    window.location.reload();
  }

  const { 
    customAlertModal, 
    showCustomAlert, 
    hideCustomAlert, 
    handleCustomAlertConfirm
  } = useCustomAlertModal(onHiddenModal);

  const openedRef = useRef(false);

  const loadCoupon = async () => {
    if (openedRef.current) {
      return;
    }
    try {
      const response = await getMyCouponById( coupon_id || 0 );
        
      if (response.status === 'success') {
        if( !!response.data ) {
          const coupon = formatClaimedCouponForDisplay(response.data);
          openedRef.current = true;
          openCouponDetail(navigation, coupon);
          return;
        } else {
          showCustomAlert(
            "Pemberitahuan",
            "Terjadi kesalahan saat mendapatkan data voucher",
            "error"
          );
        }
      }
    } catch(error) {
      console.log(error);
      showCustomAlert(
        "Pemberitahuan",
        "Terjadi kesalahan saat mendapatkan data voucher",
        "error"
      );
    }
  }

  useFocusEffect(
    React.useCallback(() => {
      async function handlePendingCoupon(){
        await loadCoupon();
      }

      handlePendingCoupon();
    }, [navigation])
  );

  return (
    <View style={styles.loadingContainer}>
      <ActivityIndicator size="large" color="#3B82F6" />
      <Text style={styles.loadingText}>Loading your coupon...</Text>

      {customAlertModal}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#F8F9FA',
  },
  loadingContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  loadingText: {
    marginTop: 12,
    fontSize: 16,
    color: '#666',
    fontFamily: 'Poppins',
  },
});
